import { Empty, Spin } from 'antd'
import { MessagesAreaProps } from 'features/drilldown/panels/global/llmPanel/types'
import { Sparkles } from 'lucide-react'
import React, { FC, useEffect, useRef } from 'react'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

import { LoadingMessage } from './LoadingMessage'
import { MessageBubble } from './MessageBubble'

const MessagesContainer = styled.div`
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  min-height: 0;
`

const HydratingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px 16px;
  color: ${({ theme }) => theme.forecast.secondaryText};
  font-size: 0.875rem;
`

export const MessagesArea: FC<MessagesAreaProps> = ({
  messages,
  showTimestamps,
  isLoading,
  isHydrating = false,
  onCopy,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null)

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages, isLoading])

  const hasMessages = messages.length > 0

  const renderBody = () => {
    if (hasMessages) {
      return messages.map((message) => (
        <MessageBubble
          key={message.id}
          message={message}
          showTimestamp={showTimestamps}
          onCopy={onCopy}
        />
      ))
    }
    if (isHydrating) {
      return (
        <HydratingState>
          <Spin />
          <span>Loading conversation...</span>
        </HydratingState>
      )
    }
    return (
      <Empty
        image={<Sparkles size={48} />}
        description='Start a conversation'
        style={{ color: CantileverTheme.colors.purple['400'] }}
      />
    )
  }

  return (
    <MessagesContainer>
      {renderBody()}
      {isLoading && <LoadingMessage />}
      <div ref={messagesEndRef} />
    </MessagesContainer>
  )
}
